import { observer } from 'mobx-react';
import React from 'react';

import PageContent from './Content';
import PageList from './List';
import { IPageProps } from './types';

function Page(props: IPageProps) {
	const { type } = props;
	if (type === 'list') {
		return <PageList {...props} />;
	}
	return <PageContent {...props} />;
}

export default observer(Page);
